import * as React from 'react'

import { cn } from '@/lib/utils'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  rootClassName?: string
  errorMessage?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ rootClassName, className, type, errorMessage = '', ...props }, ref) => {
    return (
      <div className={cn('flex flex-col gap-1', rootClassName)}>
        <input
          type={type}
          className={cn(
            'flex',
            'h-10',
            'w-full',
            'rounded-md border border-input',
            'bg-background',
            'px-3 py-2',
            'text-sm',
            'ring-offset-background',
            'file:border-0 file:bg-transparent file:text-sm file:font-medium',
            'placeholder:text-muted-foreground',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            'disabled:pointer-events-none disabled:bg-secondary disabled:text-slate-500',
            className
          )}
          ref={ref}
          aria-describedby={errorMessage ? 'error-message' : undefined}
          {...props}
        />
        {errorMessage && (
          <p id="error-message" className={cn('text-sm text-rose-600')}>
            {errorMessage}
          </p>
        )}
      </div>
    )
  }
)
Input.displayName = 'Input'

export { Input }
